export default __webpack_public_path__ + "static/media/ksztalty-vege fish.270656fb.svg";